<template>
    <div class="page">
      <div class="flex__container">

        <div class="product">
          <div class="flex__container">
            <figure class="image__container">

              <transition name="fade" appear mode="out-in">
                <img
                  class="image image--packshot"
                  alt="packshot"
                  :key="currentIndex"
                  :src="packshot"
                />
              </transition>

              <transition name="appear" appear mode="out-in">
                <img
                  class="image image--texture"
                  alt="texture"
                  :key="currentIndex"
                  :src="texture"
                />
              </transition>
            </figure>

            <transition name="fade" mode="out-in">
              <div class="info" :key="currentIndex">
                <div class="flex__container">
                  <p class="info__finish">
                    {{ finish }}
                  </p>

                  <h3 class="info__name">
                    {{ name }}
                  </h3>

                  <span class="info__description">
                    {{ description }}
                  </span>
                  <div class="color-container" v-if="!vendingFeatures || product.variants.length === 1">
                    <div class="color" :style="{backgroundColor: variant.shades[0].hexaColor}"/>
                  </div>
                  <div class="variant__info" :key="currentIndex" v-if="!vendingFeatures || product.variants.length === 1">
                    <em class="variant__code">
                      {{ variant__code }}
                    </em>

                    <span class="variant__name">
                      {{ variant__name }}
                    </span>
                  </div>
                </div>
              </div>
            </transition>
          </div>
        </div>

      <div class="variant__container" v-if="vendingFeatures && product.variants.length > 1">
        <div class="flex__container">
          <ColorSwatchesLarge  class="carousel" :variants="product.variants" :initialIndex="initialIndex" @selected="selectedVariant" />
          <transition name="fade" mode="out-in">
            <div class="variant__info" :key="currentIndex">
                <em class="variant__code">
                  {{ variant__code }}
                </em>

                <span class="variant__name">
                  {{ variant__name }}
                </span>
            </div>
          </transition>
        </div>
      </div>

      <footer class="footer" v-if="vendingFeatures">
        <div class="flex__container">
          <touch-ripple :speed="1" :opacity="0.3" color="#eee" transition="ease" @click="payment" v-if="product.variants[this.currentIndex].status === 'available' || !isElectron">
            <button class="button" type="submit" @click.prevent="payment">{{$t('payment')}}</button>
          </touch-ripple>
          <button v-else class="button out-of-stock">{{$t('outofstock')}}</button>
        </div>
      </footer>
    </div>
  </div>
</template>

<script>
import productTransition from '@/transitions/product'
import ColorSwatchesLarge from '@/components/ui/ColorSwatchesLarge'
import Product from '@/components/mixins/Product'
export default {
  data () {
    return {
      productTransition
    }
  },
  mixins: [Product],
  components: {
    ColorSwatchesLarge
  }
}
</script>

<style lang="scss" scoped>
@import '../../style/css/screens.scss';
.page {
  display: flex;
  justify-content: center;

  & > .flex__container {
    flex: 0 0 95%;
    display: grid;
    grid-template-rows: 2fr .5fr 1fr;
  }
}

.product {
  flex-grow: 2;
  display: flex;
  justify-content: center;
  align-items: center;

  & > .flex__container {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    flex: 0 1 66%;
  }
}
.image {
  width: 28vh;
  max-width: 28vh;
  min-width: 28vh;
  max-height: 28vh;
  &__container {
    flex-grow: 2;
    display: flex;
    justify-content: center;
    align-items: stretch;
    position: relative;
  }

  &--texture {
    position: absolute;
    transform: rotate(45deg);
    z-index: -1;
  }
}

.info {
  flex: 0 1 auto;
  text-align: center;

  &__finish {
    font-size: 20px;
  }

  &__name {
    font-size: 25px;
    line-height: 1.3;
    text-transform: uppercase;
    margin-bottom: 10px;
  }
  &__description {
    font-size: 20px;
  }

  @media screen and (max-width: $handheld) {
    &__finish {
      font-size: 15px;
    }

    &__name {
      font-size: 17px;
    }

    &__description {
      font-size: 15px;
    }
  }

  @media screen and (orientation: landscape) and (max-height: $handheld) {
    &__finish {
      font-size: 15px;
      margin: 0;
    }

    &__name {
      font-size: 17px;
      margin: 0;
    }

    &__description {
      font-size: 15px;
    }
  }

  @media screen and (orientation: landscape) and (max-height: 360px) {
    &__finish {
      display: none;
    }

    &__description {
      display: none;
    }
  }
}

.variant {
  &__info {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }

  &__code {
    font-weight: 600;
  }

  &__name {
    font-size: 1.2rem;
  }

  @media screen and (orientation: landscape) and (max-height: $handheld) {
    &__code {
      font-size: .8rem;
    }

    &__name {
      font-size: 1rem;
    }
  }
}

.carousel {
  flex: 1;
  margin-bottom: 5px;
}

.footer {
  flex: 1;
  display: flex;
  justify-content: center;

  & > .flex__container {
    display: flex;
    align-items: center;
  }
}

.button {
  font-size: 24px;
  font-family: 'Gotham';
  text-transform: uppercase;
  letter-spacing: 1px;
  @media screen and (max-width: $handheld) {
    font-size: 17px;
  }

  @media screen and (orientation: landscape) and (max-height: $handheld) {
    font-size: 17px;
  }
}
.out-of-stock {
  background: white;
  color: black;
}

.appear {
  &-enter, &-leave-to {
    opacity: 0;
    transform: translateY(-25%) rotate(45deg);
  }

  &-enter-active, &-leave-active {
    transition: all .35s ease-out .05s;
  }
}

.fade {
  &-enter, &-leave-to {
    opacity: 0;
  }

  &-enter-active, &-leave-active {
    transition: opacity .25s ease-in .05s;
  }
}
.color-container {
  display:flex;
  justify-content: center;
  margin-bottom: 2%;
  margin-top: 5%;
  .color {
    width: 57px;
    height: 57px;

    @media screen and (orientation: landscape) and (max-height: $handheld) {
      height: 35px;
    }
  }
}
</style>
